<template>
    

 <div class="mainMenus" >

  
    <div class="Contentframe" >
     
        <div class="leftmenu">
          <LeftMenus  :styles="styles" :active="active" :infoID="$route.query.infoID"></LeftMenus>
       </div>
 
        <div class="rightContent"> 
            <el-table :data="announcement"  stripe   style="width: 100%"   @row-click="toRouter">
                <el-table-column  prop="content"   width="500">   </el-table-column>
                <el-table-column   prop="createDate"  width="180"> </el-table-column>
          </el-table>
        </div>

   </div>
   </div>
  
    
</template>
    
    <script>
    import LeftMenus from './../LeftMenus.vue'
    export default {
      components:{LeftMenus},
      created(){
        this.selectAnnouncement()
      },
    data() {
          return {
            infoList:[],
            announcement:[],
            styles:[],
            active:[],
    
          }
        },
    mounteds:{
     
    },methods:{
      selectAnnouncement(){
      
    //     this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    // .then(resp => { 
    //                   if(resp.data.status == 1) {      
    //                     this.info=resp.data.result[0]                                                
    //                                console.log(resp.data.result[0])   
    //                                this.infoList=resp.data.result[0]   
    //                             }else {
    //                                alert("拿取数据失败")                                 
    //                             }
    //                         })
    //                         .catch((err) => {
    //                             console.log(err)
    //                         })  

                              this.active=this.$route.query.active
       this.styles=this.$route.query.styles   

        this.axios.post("/announcement/selectAnnouncementByisPublish")
         .then(resp => { 
                       if(resp.data.status == 1) {

                        console.log(resp.data.result)
                                this.announcement=resp.data.result
                                }else {
                               
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      },toRouter(data){
        console.log(data)
        this.$router.push({  //核心语句
                    name: data.router,   //跳转的路径
                    query:{'announcementId':data.announcementId,'infoID':this.$route.query.infoID,"active":this.$route.query.active,"styles":this.$route.query.styles}
                  })
console.log(data)
      }
    }
      
    
    }
    </script>
    
    <style scoped>
 
 .leftmenu
   {
     padding-left:15px;
       background:#0065bd;
     color:black;
     margin-top: 40px;
     margin-right: 20px;
     height:500px;
     width:20%;
     padding: 20px;
     box-shadow: 0px 0px 2px #ededed;
   }
  .rightContent{
  width: 80%;
  margin-left:50px;


}
 .mainMenus{
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}

.Contentframe{
  width: 90%;
  margin: auto;
  display: flex;
 
}

   
    </style>
    
    
    
    


// WEBPACK FOOTER //
// src/components/work/teacher/AccessoryList.vue